import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { ExportMode } from '../../../shared/model';
import { toolbarBackdropClass } from '../../constants';

@Component({
  selector: 'y42-download-png-button',
  templateUrl: './download-png-button.component.html',
  styleUrls: ['./download-png-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadPngComponent {
  @Output() protected readonly downloadPng = new EventEmitter<ExportMode>();

  protected readonly toolbarBackdropClass = toolbarBackdropClass;
  protected readonly exportMode = ExportMode;
}
